import { useMutation } from '@tanstack/react-query';
import useGlynt from '../useGlynt';
import { IRQCallbacks } from '../../../types/my-types';
import { Packager } from '../../../types/packager-types';

type IUsePackageTriggerDeliveryProps = {
  packagerId: string;
  packageId: string;
};

export const usePackageTriggerDelivery = (callbacks?: IRQCallbacks) => {
  const glynt = useGlynt();

  return useMutation({
    mutationFn: async (data: IUsePackageTriggerDeliveryProps) => {
      return await (await glynt).packages.triggerDelivery(data.packagerId, data.packageId);
    },

    ...callbacks
  });
};
